import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import hr from "./locales/hr.json";

export const LOCALE_KEY = "kc_locale";
export const SUPPORTED_LOCALES = ["hr", "en"];
export const DEFAULT_LOCALE = "hr";

function detectInitialLocale() {
  try {
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get("lang");
    if (fromUrl && SUPPORTED_LOCALES.includes(fromUrl)) {
      localStorage.setItem(LOCALE_KEY, fromUrl);
      return fromUrl;
    }
    const stored = localStorage.getItem(LOCALE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch {
    /* noop */
  }
  return DEFAULT_LOCALE;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hr: { translation: hr },
  },
  lng: detectInitialLocale(),
  fallbackLng: "hr",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export function setAppLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  try {
    localStorage.setItem(LOCALE_KEY, locale);
  } catch {
    /* noop */
  }
  i18n.changeLanguage(locale);
  try {
    document.documentElement.lang = locale;
  } catch {
    /* noop */
  }
}

export default i18n;
